import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import InputMask from 'react-input-mask';
// import MaterialInput from '@material-ui/core/Input';

import { useForm } from '../../../hooks/useForm';
import { formValidation } from '../../../helpers/formValidation';
import { errorFormValid, finishFormValid, startFormValid } from '../../../actions/form';
import { generatePagoTarjeta } from '../../../actions/payments';
import { msg_error } from '../../../helpers/msg_error';
import { cardIcon } from '../../../helpers/cardIcon';
import Swal from 'sweetalert2';

window.OpenPay.setId(process.env.REACT_APP_OPENPAY_ID);
window.OpenPay.setApiKey(process.env.REACT_APP_OPENPAY_PUBLIC);
window.OpenPay.setSandboxMode(process.env.REACT_APP_OPENPAY_SANDBOX_MODE);
let deviceSessionId = '';

export const Tarjeta = () => {
    
    const dispatch = useDispatch()
    const {tarjetaForm} = useSelector(state => state.forms);
    const [{inputCantidad, name, card, date, cvv}, handleInputChange, reset] = useForm({
        inputCantidad: '',
        name: '', 
        card: '', 
        date: '', 
        cvv: ''
    });
    const [cantidad, setCantidad] = useState(0);
    const [cardType, setCardType] = useState('');

    useEffect(() => {
        deviceSessionId = window.OpenPay.deviceData.setup("tarjetaForm");
    }, [])

    const handleCantidad = (e) =>{
        handleInputChange(e);
        if(!!e.target.value)
            setCantidad((e.target.value * 1.03364 + 2.5*1.16));
        else
            setCantidad(0);
    }

    const handleInputCard = (e) => {
        if( window.OpenPay.card.validateCardNumber( e.target.value.replace(/[^a-zA-Z0-9]/g, '') ))
            setCardType(window.OpenPay.card.cardType( e.target.value.replace(/[^a-zA-Z0-9]/g, '' ) ));
        else 
            setCardType('');
    }

    const handleReset = () => {
        reset();
        setCantidad(0);
    }

    const handleSubmit= (e)=>{
        formValidation(e, getToken);
    }

    const getToken = async () => {
        await dispatch(startFormValid('tarjetaForm'));
        const { value: accept } = await Swal.fire({
            title: 'Pago con tarjta',
            text: `Se realizara un pago con tarjeta por la cantidad de ${ new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(cantidad) }`,
            input: 'checkbox',
            inputValue: 0,
            inputPlaceholder:
                `Yo ${name} estoy deacuerdo.`,
            confirmButtonText:
                'Continuar <i class="fa fa-arrow-right"></i>',
            inputValidator: (result) => {
                return !result && 'Necesitas autorizar el pago.'
            }
        })
          
        if (accept) {
            window.OpenPay.token.create({
                "device_session_id": deviceSessionId,
                "card_number": card.replace(/[^a-zA-Z0-9]/g, ''),
                "holder_name": name,
                "expiration_year": date.split('/')[1],
                "expiration_month": date.split('/')[0],
                "cvv2": cvv
          }, successResponseHandler, errorResponseHandler);
        } else{
            const respond = {data:{description: 'No se concluyo la solicitud de pago.'}}
            errorResponseHandler(respond);
        }
    }

    const successResponseHandler = (response) => {
        if (response.data.card.points_card) {
              Swal.fire({
                title: 'Pagar con Puntos',
                text: "¿Desea usar los puntos de su tarjeta para realizar este pago?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No',
                allowOutsideClick: false
              }).then((result) => {
                if (result.value) {
                    dispatch(generatePagoTarjeta(inputCantidad, 'tarjetaForm', response.data, deviceSessionId, true, handleReset, false))
                } else if (
                  /* Read more about handling dismissals below */
                  result.dismiss === Swal.DismissReason.cancel
                ) {
                    dispatch(generatePagoTarjeta(inputCantidad, 'tarjetaForm', response.data, deviceSessionId, false, handleReset, false));
                }
              })
        } else {
            dispatch(generatePagoTarjeta(inputCantidad, 'tarjetaForm', response.data, deviceSessionId, false, handleReset, false));
        }



    }

    const errorResponseHandler = (response) => {
        dispatch(finishFormValid('tarjetaForm'));
        dispatch(errorFormValid('tarjetaForm', msg_error(response.data.description)))
    }

    return (
        <div>
            <form 
                name="tarjetaForm" 
                id="tarjetaForm"
                className="needs-validation needs-validation" 
                noValidate={true} 
                onSubmit={handleSubmit}
            >
                <p>Paga con tu tarjeta de <strong>debito</strong> o <strong>credito</strong>.</p>
                <h6 className="text-warning">Está forma de pago genera una comisión bancaria del 2.9% + $2.5 MXN más IVA por el procesamiento de este tipo de pago.</h6>
                <div className="row">
                    <div className="col text-center">
                        <img className="" src={`${process.env.REACT_APP_API_URL}/assets/images/cards1.png`} alt="tarjetas"/>
                        {/* <img className="w-100" src={`${process.env.REACT_APP_API_URL}/assets/images/cards2.png`} alt="bancos"/> */}
                    </div>
                </div>
                {
                    !!tarjetaForm.msg &&
                        <div className={`alert alert-${tarjetaForm.error?'danger':'success'}`} role="alert">
                            {tarjetaForm.msg}
                        </div>
                }
                <div className="row mt-3 mb-3">
                    <div className="col-md-6">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend">$</span>
                            </div>
                            <input 
                                type="text" 
                                className="form-control" 
                                aria-describedby="inputGroupPrepend" 
                                placeholder="Cantidad a abonar" 
                                name="inputCantidad"
                                value={inputCantidad}
                                onChange={handleCantidad}
                                required={true} 
                            />
                            <div className="invalid-feedback">
                                Ingresa una cantidad.
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 text-center">
                        <h6>Total con comisión:</h6>
                        <h5 className="text-success">
                            { new Intl.NumberFormat("en-US", {style: "currency", currency: "MXN"}).format(cantidad) }
                        </h5>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend"><i className="fas fa-user"></i></span>
                            </div>
                            <input 
                                type="text" 
                                id="inputcard"
                                className="form-control"
                                placeholder="Nombre como aparece en la tarjeta" 
                                autoComplete="off" 
                                data-openpay-card="holder_name"
                                name="name"
                                value={name}
                                onChange={handleInputChange}
                                required={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className="input-group buttonIn">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend"><i className="fas fa-credit-card"></i></span>
                            </div>
                            <InputMask 
                                mask='9999 9999 9999 9999'
                                maskChar={null}
                                type="text" 
                                className="form-control"
                                placeholder="Número de tarjeta" 
                                autoComplete="off" 
                                data-openpay-card="card_number"
                                style={{paddingLeft: '.7em', paddingRight: 50}}
                                name="card"
                                value={card}
                                onChange={handleInputChange}
                                onKeyUp={handleInputCard}
                                required={true}
                            />
                            {
                                cardType && 
                                    <span className="floatButton" style={{zIndex:50}}>
                                        <i className={`fab fa-cc-${cardIcon(cardType)}`} style={{fontSize: '1.5em'}}></i>
                                    </span> 
                            }
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                <div className="col-sm-6">
                        <InputMask 
                            mask="99/99" 
                            maskChar={null}
                            type="text" 
                            className="form-control"
                            placeholder="Expiración" 
                            autoComplete="off" 
                            name="date"
                            value={date}
                            onChange={handleInputChange}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-6 buttonIn">
                        <InputMask 
                            mask="9999"
                            maskChar={null}
                            type="text" 
                            className="form-control"
                            placeholder="CVV" 
                            autoComplete="off" 
                            name="cvv"
                            value={cvv}
                            onChange={handleInputChange}
                            required={true}
                        />
                        <span
                            className="floatButton"
                            style={{
                                zIndex: 50,
                                height: 45,
                                width: 35,
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url(${process.env.REACT_APP_API_URL}/assets/images/cvv.png)`,
                                backgroundPosition: `${cardType ? 'right': 'left'} center`,
                                backgroundSize: '8rem',
                                marginRight: 5,
                            }}
                        >
                        </span> 
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col d-flex align-content-center justify-content-center">
                        <button 
                            id="btn-submit-card"
                            className="btn btn-primary btn-lg" 
                            type="submit"
                            disabled={!!tarjetaForm.loading ? true : false}
                        >
                            {!!tarjetaForm.loading && <i className="spinner-border spinner-border-sm" role="status"></i>} Pagar
                        </button>
                    </div>
                </div>
                <div className="row openpay mt-3">
                    <div className="col logo">Transacciones realizadas vía:</div>
                    <div className="col shield">Tus pagos se realizan de forma segura con encriptación de 256 bits</div>
                    
                </div>
            </form>
        </div>
    )
}
